export default "__VITE_ASSET__Crll0bFH__$_?url__"